export const MSTYPE_NONE = 0;
export const MSTYPE_LINENOTIFY = 1; // TODO: 使っていないので削除する
export const MSTYPE_EMAIL = 2;
export const MSTYPE_SMS = 3;
export const MSTYPE_LINE = 4;
export const MSTYPE_APPKF = 5;
export const MSTYPE_WEB = 6;

export const TARGETTYPE_HIME = 0;
export const TARGETTYPE_DRIVER = 1;
export const TARGETTYPE_USER = 2;

export const USER_CONTACT_LINE = 0;
export const USER_CONTACT_SMS = 1;
export const USER_CONTACT_BOTH = 2;
export const userContactMap = {
  [USER_CONTACT_LINE]: 'LINE優先',
  [USER_CONTACT_SMS]: 'SMS優先',
  [USER_CONTACT_BOTH]: '両方'
};
